
import '../PaymentLoader/Loader.scss';
import CircularProgress from "@mui/material/CircularProgress"; 

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <CircularProgress size={50} />
    </div>
  );
};

export default Loader;
